module.exports = __webpack_public_path__ + "img/closed_event.30ac4091.jpeg";